<template>
    <NuxtLayout name="default" mainClass="inside_main">
        <div class="about-us">
            <div class="container">

                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="section_title">
                            <h1>
                                من نحن
                            </h1>
                        </div>
                    </div>
                </div>

                <div class="about-us-inner">

                    <!-- <div class="icon">
                        <img :src="websiteStore.websiteIcon" alt="icon">
                    </div> -->
                    <template v-if="aboutusPage">
                        <div class="row align-items-center">
                            <div class="col-md-6">
                                
                                <div v-html="aboutusPage.content"></div>
                            </div>
                            <div class="col-md-6">
                                <img src="/website/assets/img/business/expert-hero.png?v=1" alt="hero img" class="floating_img_none">
                            </div>
                        </div>
                        
                    </template>
                    
                    
                    <!-- <template v-else>
                        <p>جاري تحميل الشروط والأحكام...</p>
                    </template> -->

                    <!-- <p>
                    {{websiteStore?.initializationData?.memberships.content}}
                </p> -->


                </div>

            </div>
        </div>
    </NuxtLayout>


</template>

<script setup lang="ts">

import { useWebsiteStore } from '~/store/website'
import { computed } from 'vue'
const websiteStore = useWebsiteStore()


// استخراج الصفحة التي تحمل `label === "about_us"`
const aboutusPage = computed(() => {
    return websiteStore.initializationData?.pages?.find(page => page.label === "about_us") || null;
})

useHead({
    title: 'من نحن',
    meta: [
    { property: 'og:title', content: `من نحن | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
    { property: 'twitter:title', content: `من نحن | رفيو المنصة الأولى في التقييم و معرفة تجارب الآخرين و الاستفادة منها` },
    ]
})

</script>